export class LoginFormDto {
  login:string;
  password:string;
}
